<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">现金券库管理-创建</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   @click="preservation">保存</el-button>
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div class="biaoti">
      <span>基本信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form :rules="BasicDataRules"
                   :label-position="labelPosition"
                   label-width="155px"
                   size="small"
                   class="form-div"
                   ref="BasicInformation"
                   :model="BasicData">
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库名称"
                              prop="couponsName">
                  <el-input v-model="BasicData.couponsName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="券库后台名称"
                              prop="innerCoupName">
                  <el-input v-model="BasicData.innerCoupName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼券金额"
                              prop="coupValue">
                  <el-input type="Number"
                            v-model="BasicData.coupValue"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用的业务系统"
                              prop="systemBusinessSelect">
                  <el-checkbox-group v-model="BasicData.systemBusinessSelect">
                    <el-checkbox :label="item.appName"
                                 v-model="item.IsCheck"
                                 :checked="item.IsCheck"
                                 v-for="(item, index) in BasicData.systemBusiness"
                                 :key="index"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券可用门店"
                              prop="isAllStore">
                  <el-radio-group v-model="BasicData.isAllStore">
                    <el-radio label="全部门店"></el-radio>
                    <el-radio label="部分门店"></el-radio>
                    <el-button size="mini"
                               :disabled="BasicData.isAllStore != '部分门店'"
                               @click="outletVisible = true">选择门店</el-button>
                  </el-radio-group>
                  <!-- listOfSomeStoreslStr -->
                  <el-form-item :prop="isStoreSelectionMethod">
                    <textarea name=""
                              id=""
                              rows="8"
                              readonly
                              class="textareaClass textareaClass-store"
                              v-model="BasicData.listOfSomeStoreslStr"></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用需知"
                              prop="usageNotice">
                  <el-input type="textarea"
                            class="textareaClass"
                            :autosize="{ minRows: 4, maxRows: 8 }"
                            v-model="BasicData.usageNotice">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item prop="isLimitGoodsDiscount"
                              label="是否进行商品折扣限制">
                  <el-checkbox-group @change="changeisLimitGoodsDiscount"
                                     v-model="BasicData.isLimitGoodsDiscount">
                    <el-checkbox :checked="BasicData.isLimitGoodsDiscount"
                                 v-model="BasicData.isLimitGoodsDiscount"
                                 name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最高折扣"
                              prop="maxDiscount"
                              :rules="
                    BasicData.isLimitGoodsDiscount
                      ? [
                          {
                            required: true,
                            message: '请输入最高折扣',
                            trigger: 'blur',
                          },
                        ]
                      : [{ required: false }]
                  ">
                  <el-input type="Number"
                            :disabled="!BasicData.isLimitGoodsDiscount"
                            v-model="BasicData.maxDiscount"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品不可转赠">
                  <el-checkbox-group v-model="BasicData.ifGiving">
                    <el-checkbox :checked="BasicData.ifGiving"
                                 v-model="BasicData.ifGiving"
                                 name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最多使用张数"
                              prop="useMaxQty">
                  <el-input type="Number"
                            v-model="BasicData.useMaxQty"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="使用最低金额限制"
                              prop="amountLimit">
                  <el-input type="Number"
                            v-model="BasicData.amountLimit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券有效期"
                              prop="SecuritiesExpirationTypeSelect">
                  <el-radio-group v-model="BasicData.SecuritiesExpirationTypeSelect"
                                  class="periodOfValidity">
                    <el-form-item prop="123">
                      <el-radio :label="SecuritiesExpirationType[0].id">永不过期</el-radio>
                    </el-form-item>
                    <el-form-item prop="validDaySdata">
                      <el-radio :label="SecuritiesExpirationType[1].id">
                        <span style="font-size: 14px">有效期天数，从领券日期起</span>
                        <el-input :disabled="
                            BasicData.SecuritiesExpirationTypeSelect != 2
                          "
                                  style="width: 90px"
                                  type="Number"
                                  v-model="BasicData.validDaySdata"></el-input>
                        <span style="font-size: 14px">天内有效</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item prop="datePicker">
                      <el-radio :label="SecuritiesExpirationType[2].id">
                        <span style="font-size: 14px">有效期范围从</span>
                        <el-date-picker :disabled="
                            BasicData.SecuritiesExpirationTypeSelect != 3
                          "
                                        v-model="BasicData.datePicker"
                                        type="daterange"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        :picker-options="pickerOptions">
                        </el-date-picker>
                      </el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券发送提醒">
                  <el-radio-group v-model="BasicData.pubCoupProvideMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券核销提醒">
                  <el-radio-group v-model="BasicData.pubVeriCoupMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24"
                      class="MaturityOfSecurities">
                <el-form-item label="券到期提醒">
                  <el-radio-group v-model="BasicData.expirationMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="expirationTime"
                              style="margin-left: -50px">
                  <span style="font-size: 14px">券到期前</span>
                  <el-input style="width: 90px"
                            type="Number"
                            v-model="BasicData.expirationTime"></el-input>
                  <span style="font-size: 14px">天提醒</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <SelectProduct ref="Prod"></SelectProduct>
      </el-card>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog width="30%"
                   :visible.sync="outletVisible"
                   title="礼品券库管理-创建-选择门店">
          <el-form size="mini"
                   label-width="90px"
                   :label-position="labelPosition">
            <el-row :gutter="50"
                    v-for="(item, index) in StoreSelectionList"
                    :key="index">
              <el-col :span="12"
                      v-for="(myitem, myindex) in item"
                      :key="myindex">
                <el-tree ref="tree"
                         v-if="myitem != undefined"
                         :data="[myitem]"
                         show-checkbox
                         node-key="id"
                         highlight-current
                         default-expand-all
                         :props="defaultProps">
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="ComButtomStore">确 定</el-button>
            <el-button @click="outletVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  couponsGroupCreate,
  couponsGroupOutappList,
} from "@/api/couponsDepot.js";
import { GetShopQueryRegion } from "@/api/viewMemberModule.js";
import SelectProduct from "/src/components/SelectProduct/index.vue";
export default {
  components: {
    SelectProduct: SelectProduct,
  },
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      pickerOptions: {
        shortcuts: [
          {
            text: "一周",
            onClick (picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一个月",
            onClick (picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "三个月",
            onClick (picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一年",
            onClick (picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "两年",
            onClick (picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 2);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      SecuritiesExpirationType: [
        {
          id: 1,
          detailText: "永不过期",
        },
        {
          id: 2,
          detailText: "从发卷开始固定日期",
        },
        {
          id: 3,
          detailText: "固定过期时间",
        },
      ],
      CouponreminderMethod: [
        {
          id: 0,
          detailText: "不提醒",
        },
        {
          id: 1,
          detailText: "公众号模板消息",
        },
        {
          id: 2,
          detailText: "短信消息",
        },
        {
          id: 3,
          detailText: "公众号模板消息和短信消息",
        },
      ],
      BasicDataRules: {
        couponsName: [
          { required: true, message: "请输入券库名称", trigger: "blur" },
        ],
        innerCoupName: [
          { required: true, message: "请输入券库后台名称", trigger: "blur" },
        ],
        coupValue: [
          { required: true, message: "请输入礼券金额", trigger: "blur" },
        ],
        systemBusinessSelect: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个业务系统",
            trigger: "change",
          },
        ],
        isAllStore: [
          { required: true, message: "请选择使用门店类型", trigger: "change" },
        ],
        listOfSomeStoreslStr: [
          {
            required: true,
            message: "请点击按钮选择部分门店",
            trigger: "change",
          },
        ],
        usageNotice: [
          { required: false, message: "请输入使用需知", trigger: "blur" },
        ],
        maxDiscount: [
          { required: true, message: "请输入最高折扣", trigger: "blur" },
        ],
        useMaxQty: [
          { required: true, message: "请输入最高使用张数", trigger: "blur" },
        ],
        amountLimit: [
          {
            required: true,
            message: "请输入最低使用金额限制",
            trigger: "blur",
          },
        ],
        SecuritiesExpirationTypeSelect: [
          { required: true, message: "请选择劵有效期类别", trigger: "change" },
        ],
        validDaySdata: [
          { required: true, message: "请输入过期天数", trigger: "blur" },
        ],
        datePicker: [
          {
            required: true,
            message: "请选择有效期范围",
            trigger: "blur",
          },
        ],
        expirationTime: [
          {
            required: true,
            message: "请输入劵到期提前多少天提醒",
            trigger: "blur",
          },
        ],
      },
      BasicData: {
        //基本信息
        couponsName: "", //券库名称
        innerCoupName: "", //券库后台名称
        coupValue: "", //礼券金额
        systemBusiness: [], //使用的业务系统
        systemBusinessSelect: [], //选中业务系统
        isAllStore: "全部门店", //是否全门店可用
        listOfSomeStoresl: [], //选部分门店是选择的部分门店
        listOfSomeStoreslStr: "", //选部分门店是选择的部分门店组装数据
        usageNotice: "", //使用需知
        isLimitGoodsDiscount: false, //是否对商品的折扣进行限制
        maxDiscount: "", //最高折扣
        ifGiving: false, //礼品是否可以转送
        useMaxQty: 1, //最多使用张数
        amountLimit: 0, //使用最低金额限制
        SecuritiesExpirationTypeSelect: 1, //选择的劵有效期方式
        validDaySdata: "  ",
        datePicker: "  ",
        pubCoupProvideMode: 0, //券发放提醒方式
        expirationMode: 0, //到期提醒方式
        pubVeriCoupMode: 0, //券核销提醒方式
        expirationTime: 0, //到期提醒时间
      },
      outletVisible: false,
      labelPosition: "right",
      // 选择门店数据
      StoreSelectionList: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      StoredataArray: [],
      StoreSelectLength: 0,
    };
  },
  watch: {
    //窗口宽度变化
    screenWidth (val) {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
    type (val) {
      if (val == 1) {
        this.BasicData.validDaySdata = "  ";
        this.BasicData.datePicker = "  ";
      }
      if (val == 2) {
        this.BasicData.validDaySdata = "";
        this.BasicData.datePicker = "  ";
      }
      if (val == 3) {
        this.BasicData.validDaySdata = "  ";
        this.BasicData.datePicker = "";
      }
    },
  },
  computed: {
    type () {
      return this.BasicData.SecuritiesExpirationTypeSelect;
    },
    isStoreSelectionMethod () {
      if (this.BasicData.isAllStore == "部分门店") {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
  },
  created () {
    this.RcouponsGroupOutappList();
    this.RGetShopQueryRegion(); //获取区域和门店
  },
  mounted () {
    this.getELmentHeight(); //获取页面高度
  },
  methods: {
    changeisLimitGoodsDiscount (e) {
      if (!e) {
        this.BasicData.maxDiscount = "";
      }
    },
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    Butpreservation () {
      this.$confirm("是否确认保存数据", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "保存",
        cancelButtonText: "放弃",
      })
        .then(() => {
          this.requestDey();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "放弃保存",
          });
        });
    },
    renderTime (date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    requestDey () {
      // 组装数据
      let isAllStore = this.BasicData.isAllStore == "全部门店" ? true : false; //是否选择全部门店
      let endDate = "",
        startDate = "",
        outApplicateionIDS = [],
        shopIDS = [],
        isAllProduct = 0,
        productLimitKind = 1,
        productMode = 0,
        limitContainBD = 0,
        atrrValues = [],
        lblIDs = [];
      if (this.BasicData.SecuritiesExpirationTypeSelect == 2) {
        //劵有效期
      } else if (this.BasicData.SecuritiesExpirationTypeSelect == 3) {
        //劵有效期
        if (this.BasicData.datePicker.length > 0) {
          startDate = this.renderTime(this.BasicData.datePicker[0]).substring(
            0,
            10
          );
          endDate = this.renderTime(this.BasicData.datePicker[1]).substring(
            0,
            10
          );
        }
      }
      if (this.BasicData.expirationTime <= 0) {
        //到期提醒时间
        this.BasicData.expirationTime = 0;
      }
      if (this.BasicData.systemBusinessSelect.length > 0) {
        //      业务系统
        this.BasicData.systemBusinessSelect.forEach((item) => {
          this.BasicData.systemBusiness.forEach((myitem) => {
            if (item == myitem.appName) {
              outApplicateionIDS.push(myitem.outApplicateionID);
            }
          });
        });
      }
      if (!isAllStore && this.BasicData.listOfSomeStoresl.length > 0) {
        //处理选择其他门店
        this.BasicData.listOfSomeStoresl.forEach((item) => {
          shopIDS.push(item.id);
        });
      }
      let SecuritiesUsablegoods = this.$refs.Prod.SecuritiesUsablegoods,
        searchCategoryFormhy = this.$refs.Prod.searchCategoryFormhy,
        searchCategoryLabelFormhy = this.$refs.Prod.searchCategoryLabelFormhy,
        GoodsFormhy = this.$refs.Prod.GoodsFormhy,
        GoodsLableFormhy = this.$refs.Prod.GoodsLableFormhy;

      if (SecuritiesUsablegoods.CommodityCategory == "所有商品") {
        isAllProduct = 1;
      } else {
        isAllProduct = 0;
      }

      if (SecuritiesUsablegoods.GoodsGenre == "按商品") {
        productLimitKind = 2;
      } else if (SecuritiesUsablegoods.GoodsGenre == "按类别") {
        productLimitKind = 1;
      } else {
        productLimitKind = "";
      }

      if (
        SecuritiesUsablegoods.GenreType == "按类别筛选" ||
        SecuritiesUsablegoods.GoodsType == "按商品筛选"
      ) {
        productMode = 1;
        if (SecuritiesUsablegoods.GenreType == "按类别筛选") {
          searchCategoryFormhy.SelectCategoryData.forEach((item) => {
            atrrValues.push(item.categoryID);
          });
        } else if (SecuritiesUsablegoods.GoodsType == "按商品筛选") {
          GoodsFormhy.SelectGoodsData.forEach((item) => {
            atrrValues.push(item.ProductCode);
          });
        }
      } else if (
        SecuritiesUsablegoods.GenreType == "按类别标签筛选" ||
        SecuritiesUsablegoods.GoodsType == "按商品标签筛选"
      ) {
        productMode = 2;
        if (SecuritiesUsablegoods.GenreType == "按类别标签筛选") {
          searchCategoryLabelFormhy.SelectCategoryLabelData.forEach((item) => {
            lblIDs.push(item.lblID);
          });
        } else if (SecuritiesUsablegoods.GoodsType == "按商品标签筛选") {
          GoodsLableFormhy.SelectGoodsLableData.forEach((item) => {
            lblIDs.push(item.lblID);
          });
        }
      } else {
        productMode = "";
      }

      if (
        SecuritiesUsablegoods.GenreTypeRegion1 == "包含" ||
        SecuritiesUsablegoods.GenreTypeRegion2 == "包含" ||
        SecuritiesUsablegoods.GoodsTypeRegion1 == "包含" ||
        SecuritiesUsablegoods.GoodsTypeRegion2 == "包含"
      ) {
        limitContainBD = 1;
      } else if (
        SecuritiesUsablegoods.GenreTypeRegion1 == "排除" ||
        SecuritiesUsablegoods.GenreTypeRegion2 == "排除" ||
        SecuritiesUsablegoods.GoodsTypeRegion1 == "排除" ||
        SecuritiesUsablegoods.GoodsTypeRegion2 == "排除"
      ) {
        limitContainBD = 2;
      } else {
        limitContainBD = "";
      }
      let data = require("qs").stringify({
        couponsName: this.BasicData.couponsName, //券名称
        innerCoupName: this.BasicData.innerCoupName, //券后台名称
        isAllStore: isAllStore, //是否全门店可用
        isLimitGoodsDiscount: this.BasicData.isLimitGoodsDiscount, //是否商品折扣限制
        usageNotice: this.BasicData.usageNotice, //使用需知
        useMaxQty: this.BasicData.useMaxQty, //最多使用张数
        amountLimit: this.BasicData.amountLimit, //使用最低金额限制
        coupValue: this.BasicData.coupValue, //礼券金额
        couponsKind: "0", //劵类型
        startDate: startDate, //开始时间
        endDate: endDate, //结束日期
        expirationMode: this.BasicData.expirationMode, //到期提醒方式
        pubCoupProvideMode: this.BasicData.pubCoupProvideMode, //券发放提醒方式
        pubVeriCoupMode: this.BasicData.pubVeriCoupMode, //券发放提醒方式
        expirationTime: this.BasicData.expirationTime, //到期提醒时间
        ifGiving: this.BasicData.ifGiving, //礼券不可转赠
        isGFCoup: false, //是否GF礼券
        maxDiscount: this.BasicData.maxDiscount, //最高折扣
        outApplicateionID: outApplicateionIDS.join(","), //业务系统
        shopID: shopIDS.join(","), //选择可用门店数组
        timeLimitKind: this.BasicData.SecuritiesExpirationTypeSelect, //劵有效期
        isAllProduct: isAllProduct, //是否商品受限
        productLimitKind: productLimitKind, //受限类型
        productMode: productMode, //商品识别方式
        limitContainBD: limitContainBD, //受限操作
        atrrValue: atrrValues.join(","), //选择的类别编码或商品编码
        ValidDay: this.BasicData.validDaySdata, //券有效日期
        lblID: lblIDs.join(","), //选择标签数组
      });
      couponsGroupCreate(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.backHistory();
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    preservation () {
      //提交保存 创建卷库
      this.$refs.BasicInformation.validate((valid) => {
        if (!valid) return true;
        this.Butpreservation();
      });
    },

    ComButtomStore () {
      //获取已选择的门店数据
      this.BasicData.listOfSomeStoresl = [];
      this.BasicData.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.BasicData.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.BasicData.listOfSomeStoresl.push(...item);
        }
      }
      this.BasicData.listOfSomeStoresl.forEach((item) => {
        this.BasicData.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // this.BasicData.listOfSomeStoreslStr =
      //   this.BasicData.listOfSomeStoreslStr.substring(
      //     0,
      //     this.BasicData.listOfSomeStoreslStr.length - 2
      //   );
      console.log(this.BasicData.listOfSomeStoreslStr.length)
      this.outletVisible = false;
    },
    RGetShopQueryRegion () {
      //获取区域和门店
      GetShopQueryRegion().then((res) => {
        console.log("res", res);
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          console.log("StoredataArray", this.StoredataArray);
          this.StoredataArray.forEach((item, index) => {
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          console.log("arr1", arr1);
          console.log("arr2", arr2);
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
        console.log("StoreSelectionList", this.StoreSelectionList);
      });
    },
    RcouponsGroupOutappList () {
      //获取业务数据
      couponsGroupOutappList().then((res) => {
        if (res.success) {
          res.data.forEach((item) => {
            item.IsCheck = false;
          });
          this.BasicData.systemBusiness = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    backHistory () {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.table-styleDetail {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  width: 1120px;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
.cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
